// ─────────────────────────────────────────────────────────────────────
//  Toggle « utiliser mon compte » pour le prefill (paiement + formulaires).
//
//  Quand un visiteur connecté ne veut PAS rattacher ce paiement / cette
//  soumission à son compte (« ce n'est pas moi »), on désactive le prefill pour
//  toute la SESSION DE NAVIGATION (sessionStorage) — l'état se propage entre la
//  page de formulaire et la page de paiement (même onglet), et se réinitialise à
//  la fermeture de l'onglet (au prochain passage, le compte est de nouveau proposé).
//
//  On ne déconnecte PAS le compte (ACCOUNT_TOKEN intact) : on coupe seulement son
//  usage pour le prefill. L'alert reste affichée, inversée, pour permettre de le
//  réactiver à tout moment.
//
//  SSR-safe : sessionStorage n'est lu/écrit que côté navigateur.
// ─────────────────────────────────────────────────────────────────────

export const ACCOUNT_PREFILL_DISABLED_KEY = "ACCOUNT_PREFILL_DISABLED"

/** true si le visiteur a désactivé l'usage de son compte pour cette session. */
export function isAccountPrefillDisabled() {
    if (typeof window === "undefined") return false
    try {
        return window.sessionStorage?.getItem(ACCOUNT_PREFILL_DISABLED_KEY) === "1"
    } catch (_) {
        return false
    }
}

/** Désactive (true) ou réactive (false) l'usage du compte pour le prefill. */
export function setAccountPrefillDisabled(disabled) {
    if (typeof window === "undefined") return
    try {
        if (disabled) {
            window.sessionStorage?.setItem(ACCOUNT_PREFILL_DISABLED_KEY, "1")
        } else {
            window.sessionStorage?.removeItem(ACCOUNT_PREFILL_DISABLED_KEY)
        }
    } catch (_) { /* sessionStorage indisponible → no-op */ }
}
